import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Box, Typography, Tooltip, ClickAwayListener } from '@material-ui/core'
import GoogleMap from 'google-map-react'
import { useStyles } from './styles'
import { mapKey } from '../../utils/googleMapKey'
import history from '../../routes/history'
import optin from '../../Assets/Images/optin.svg'
import optout from '../../Assets/Images/optout.svg'
import { VisibilityOutlined, VisibilityOffOutlined } from '@material-ui/icons'

function EventMaps(props) {
  const classes = useStyles()
  const [sites, setSites] = useState([])
  const [showCard, setShowCard] = useState(false)
  const [selectedSiteId, setSelectedSiteId] = useState('')
  const [showMap, setShowMap] = useState(true)

  useEffect(() => {
    setSites(props.data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data])

  useEffect(() => {
    document.addEventListener('scroll', handleClose, true)

    return () => {
      document.removeEventListener('scroll', handleClose, true)
    }
  }, [])

  const handleClose = () => {
    setShowCard(false)
    setSelectedSiteId('')
  }

  const getCenterPoint = () => {
    if (_.isEmpty(sites)) {
      return [42.4072, -71.3824]
    }

    return [_.get(sites[0], 'latitude', ''), _.get(sites[0], 'longitude', '')]
  }

  const handleSystemClick = (siteId) => {
    history.push({
      pathname: `/programs/${props.programId}/systems/${siteId}`
    })
  }

  const renderToolTip = (obj) => {
    const siteId = _.get(obj, 'site_id', '')
    const eventType = (props.eventDetails && props.eventDetails.type) || ''
    const label = eventType === 'BATTERY_DISCHARGE' ? 'Energy Discharged' : 'Energy Charged'
    const value = eventType === 'BATTERY_DISCHARGE' ? _.get(obj, 'Kwh_energy_dispatched', 0) : _.get(obj, 'Kwh_energy_charged', 0)

    return (
      <Box className={classes.tooltipWrapper}>
        <Box className={classes.row}>
          <Typography className={classes.label}>Site ID</Typography>
          <Typography className={classes.value}>{siteId}</Typography>
        </Box>
        <Box className={classes.row}>
          <Typography className={classes.label}>{label}</Typography>
          <Typography className={classes.value}>{value} kWh</Typography>
        </Box>
        <Typography className={classes.viewDetails} onClick={() => handleSystemClick(siteId)}>View System Details</Typography>
      </Box>
    )
  }

  const handleClick = (obj) => {
    setSelectedSiteId(obj.site_id)
    setShowCard(true)
  }

  const Marker = (obj) => {
    return (
      <ClickAwayListener onClickAway={handleClose}>
        <Tooltip
          title={renderToolTip(obj)}
          classes={{ tooltip: classes.tooltip, arrow: classes.arrow, popper: classes.popper }}
          onClose={handleClose}
          open={showCard && obj.site_id === selectedSiteId}
          arrow
          disableFocusListener
          disableHoverListener
          disableTouchListener
        >
          {<img src={obj.type === "optIn" ? optin : optout} className={classes.marker} alt="" onClick={() => handleClick(obj)} width="30" height="30" />}
        </Tooltip>
      </ClickAwayListener >
    )
  }

  return (
    <Box>
      <Box className={classes.contentTitle} display="flex" justifyContent="space-between">
        <Box>Locations</Box>
        {showMap ? <VisibilityOffOutlined className={classes.eyeIcon} onClick={() => setShowMap(showMap => !showMap)} /> : <VisibilityOutlined className={classes.eyeIcon} onClick={() => setShowMap(showMap => !showMap)} />}
      </Box>
      {showMap &&
        <>
          <Box className={classes.mapWrapper}>
            <GoogleMap
              center={getCenterPoint()}
              zoom={props.zoom}
              apiKey={mapKey}
            >
              {sites.map(obj => (
                <Marker lat={obj.latitude} lng={obj.longitude} {...obj} />
              ))}
            </GoogleMap>
          </Box>
          <Box className={`${classes.flex} ${classes.mapDotWrapper}`}>
            <Box className={`${classes.flex} ${classes.mapDotContainer}`} alignItems="center">
              <img src={optin} className={classes.legendMarker} alt="" width="40" height="40" />
              <Typography className={classes.highlightLabel}>Systems Opted In</Typography>
            </Box>
            <Box className={`${classes.flex} ${classes.mapDotContainer}`} alignItems="center">
              <img src={optout} className={classes.legendMarker} alt="" width="40" height="40" />
              <Typography className={classes.highlightLabel}>Systems Opted Out</Typography>
            </Box>
          </Box>
        </>
      }
    </Box>
  )
}

EventMaps.defaultProps = {
  zoom: 5,
  data: {},
  eventDetails: {}
}

export default EventMaps